module.exports = __webpack_public_path__ + "static/src/content/silks/santa_ana_lane.9b8b61c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/santa_ana_lane.png
// module id = tDKf
// module chunks = 0